export default "__VITE_ASSET__e963439d__"